module.exports = __webpack_public_path__ + "img/icon-fg_t.64ae7bec.png";